import { render, staticRenderFns } from "./dishDisplay.vue?vue&type=template&id=06faefb1&scoped=true"
import script from "./dishDisplay.vue?vue&type=script&lang=js"
export * from "./dishDisplay.vue?vue&type=script&lang=js"
import style0 from "./dishDisplay.vue?vue&type=style&index=0&id=06faefb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06faefb1",
  null
  
)

export default component.exports